import { Card, CircularProgress, Grid, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { IdentificationStatus, FeeStatus, RegistrationStatus, MatchStatus } from "../../Base/AdoptionConstants";
import RegistrationSearchResults from "../RegistrationSearch/RegistrationSearchResults";
import MatchSearchResults from "../MatchSearch/MatchSearchResults";
import { getDashboardCounts } from "../../Base/Services/DashboardService";
import useAdminContext from "../AdminContextProvider";

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(2),
    textAlign: "center",
    height: "fit-content",
    margin: "0.5rem",
  },
  cardNumber: {
    fontSize: "200%",
  },
  cardDescription: {
    fontSize: "100%",
  },
}));

const CRITERIA_FOR_REGISTRATIONS_TO_SEARCH = {
  registrationStatus: [RegistrationStatus.NEEDS_RESEARCH.value, RegistrationStatus.REGISTERED.value],
  identificationStatus: [IdentificationStatus.VERIFIED.value],
  feeStatus: [FeeStatus.FEE_WAIVED.value, FeeStatus.FEE_PAID.value],
};

const CRITERIA_FOR_REGISTRATIONS_TO_VERIFY = {
  identificationStatus: [
    IdentificationStatus.PENDING_REVIEW_MAIL.value,
    IdentificationStatus.PENDING_REVIEW_UPLOAD.value,
  ],
  FeeStatus: [FeeStatus.UPDATE_FEE_PENDING.value, FeeStatus.FEE_PENDING.value, FeeStatus.PREV_PAID_PENDING.value],
  byFeeOrIdStatus: true,
};

const CRITERIA_FOR_SUGGESTED_MATCHES = {
  matchStatus: [MatchStatus.MATCH_SUGGESTED.value],
  feeStatus: [FeeStatus.FEE_WAIVED.value, FeeStatus.FEE_PAID.value],
  identificationStatus: [IdentificationStatus.VERIFIED.value],
};

const CRITERIA_FOR_IN_PROCESS_MATCHES = {
  matchStatus: [MatchStatus.MATCH_INPROCESS.value],
  feeStatus: [FeeStatus.FEE_WAIVED.value, FeeStatus.FEE_PAID.value],
  identificationStatus: [IdentificationStatus.VERIFIED.value],
};

export default function AdminDashboard() {
  const classes = useStyles();
  const adminContext = useAdminContext();
  const [displayCounts, setDisplayCounts] = React.useState(null);
  const [processingCounts, setProcessingCounts] = React.useState(false);

  React.useEffect(() => {
    setProcessingCounts(true);
    getDashboardCounts().then(setDisplayCounts).finally(setProcessingCounts(false));
  }, [adminContext.dataResyncFlag]);

  return (
    <>
      <Typography variant="h2" gutterBottom style={{ marginTop: 16 }}>
        Dashboard
      </Typography>

      <Grid style={{ display: "flex", justifyContent: "space-evenly", width: "100%", flexWrap: "wrap" }}>
        <Card className={classes.card}>
          <span className={classes.cardNumber}>
            {processingCounts ? <CircularProgress /> : displayCounts?.totalRegistrations}
          </span>
          <div className={classes.cardDescription}>Total Registrations</div>
        </Card>
        <Card className={classes.card}>
          <span className={classes.cardNumber}>
            {processingCounts ? <CircularProgress /> : displayCounts?.suggestedMatches}
          </span>
          <div className={classes.cardDescription}>Suggested Matches</div>
        </Card>
        <Card className={classes.card}>
          <span className={classes.cardNumber}>
            {processingCounts ? <CircularProgress /> : displayCounts?.totalMatches}
          </span>
          <div className={classes.cardDescription}>Confirmed Matches</div>
        </Card>
        <Card className={classes.card}>
          <span className={classes.cardNumber}>
            {processingCounts ? <CircularProgress /> : displayCounts?.last30DayRegistrations}
          </span>
          <div className={classes.cardDescription}>New Registrations Last 30 Days</div>
        </Card>
      </Grid>

      <Typography variant="h3" style={{ margin: "1rem 0" }}>
        Registrations To Search
      </Typography>
      <RegistrationSearchResults inputSearchCriteria={CRITERIA_FOR_REGISTRATIONS_TO_SEARCH} defaultRowsPerPage={5} />

      <Typography variant="h3" style={{ margin: "1rem 0" }}>
        Registrations Pending Identity Verification Or Payment
      </Typography>
      <RegistrationSearchResults inputSearchCriteria={CRITERIA_FOR_REGISTRATIONS_TO_VERIFY} defaultRowsPerPage={5} />
      <Typography variant="h3" style={{ margin: "1rem 0" }}>
        Suggested Matches to Review
      </Typography>
      <MatchSearchResults inputSearchCriteria={CRITERIA_FOR_SUGGESTED_MATCHES} defaultRowsPerPage={5} />
      <div style={{ paddingBottom: 120 }}>
        <Typography variant="h3" style={{ margin: "1rem 0" }}>
          In Process Matches to Complete
        </Typography>
        <MatchSearchResults
          style={{ paddingBottom: 80 }}
          inputSearchCriteria={CRITERIA_FOR_IN_PROCESS_MATCHES}
          defaultRowsPerPage={5}
        />
      </div>
    </>
  );
}
